webpackJsonp([182311834751345],{

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(18);
	
	var _i18n = __webpack_require__(23);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	__webpack_require__(77);
	
	var _const = __webpack_require__(382);
	
	var _link = __webpack_require__(54);
	
	var _link2 = _interopRequireDefault(_link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _reactRouter.withRouter)(function Requirements(_ref) {
	  var location = _ref.location,
	      data = _ref.data;
	
	  var ln = (0, _i18n.lang)(location);
	  return _react2.default.createElement(
	    'div',
	    { lang: ln },
	    _react2.default.createElement(_i18n.TitleDescription, { texts: {
	        en: { title: 'Call for Papers', desc: 'DroidKaigi2018 is currently accepting speaker applications.' },
	        ja: { title: '募集要項', desc: 'DroidKaigi 2018での発表者を募集しています。' }
	      } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'subpage-title-wrapper bg-gray2' },
	      _react2.default.createElement(
	        'h2',
	        { className: 'text-yellow1' },
	        _react2.default.createElement(Text, { id: 'title' })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'subpage-container' },
	      _react2.default.createElement(
	        'h2',
	        null,
	        _react2.default.createElement(Text, { id: 'finished' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'subpage-container-disabled' },
	        _react2.default.createElement(Text, { id: 'body' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: '40px' } },
	        _react2.default.createElement(
	          _link2.default,
	          { to: '/proposals/', className: 'subpage-button-black' },
	          _react2.default.createElement(Text, { id: 'checkSubmits' })
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'subpage-button-green-disabled' },
	          _react2.default.createElement(Text, { id: 'submitTalk' })
	        )
	      )
	    )
	  );
	});
	
	
	function pastRequirements() {
	  return _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      'a',
	      { className: 'subpage-link', href: 'https://docs.google.com/spreadsheets/d/186-gpTHPvGwtQTFqvuSs10Tz3ca49gKNZ7uoRSi2HnE/edit#gid=0' },
	      '2015'
	    ),
	    '\xA0',
	    _react2.default.createElement(
	      'a',
	      { className: 'subpage-link', href: 'https://docs.google.com/spreadsheets/d/1XEkt0MWC_vBI2BHBH0qwHxM7QdqajP3zu1lDnCytJoU/edit#gid=0' },
	      '2016'
	    ),
	    '\xA0',
	    _react2.default.createElement(
	      'a',
	      { className: 'subpage-link', href: 'https://docs.google.com/spreadsheets/d/1k4bpUjpAyiJfTCJCFc9y48FYQAujZfCA_fxsmN2M4LI/edit#gid=0' },
	      '2017'
	    )
	  );
	}
	
	var Text = (0, _i18n2.default)({
	  en: {
	    title: 'Call for Papers',
	    checkSubmits: 'Check Talk Stats',
	    submitTalk: 'Submit Talk!',
	    finished: 'Call for Speakers is closed. Thank you for your applications!',
	    body: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'About DroidKaigi'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'DroidKaigi is a conference tailored for developers organized by developers. Its main focus is to provide developers a place to network and share knowledge with their peers.',
	        _react2.default.createElement('br', null),
	        'DroidKaigi 2017 saw over 800 developers with 76 sessions.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Call for Papers'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'DroidKaigi2018 is currently accepting speaker applications. Please choose a topic from the list below and fill out the form with your talk\u2019s title and abstract. For better session selection, topics have been further segmented this year.'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Topics'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'UI and Design'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Material Design'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Drawables'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Animations etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Designing App Architecture'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Clean Architecture'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Android Architecture Components'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'MVVM, MVC, MVP'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'DI etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Development Process and Methodology'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Growth Hacks'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Release Management'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Android/iOS Parallel Development etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Team Building and Development Conventions'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Team Development/Team Building'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Code Review etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'CI'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'CircleCI, Jenkins, TravisCI, Bitrise'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'OpenSTF, FirebaseTestLab etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Hardware and IoT'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Cameras, Sensors'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Video, Images, and Audio Technology'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Arduino, Drones etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Quality and Sustainability'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Operation'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Testing'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Backward Compatibility/Device Compatibility'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Security'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Android O'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Doze'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Notifications etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Android Framework and Support Library'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Inside Android, Media, Protocol Stacks'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'OS Version Differences etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'OSS Development and Management'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'OSS Development and Management as an Individual'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Community-driven OSS Development and Management etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Hands-on Codelabs'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Kotlin Hands-on Lab'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Hybrid Framework Hands-on Lab'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Productivity and Tools'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Android Studio'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Build Systems(Speed, Efficiency etc.)'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Firebase etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Platforms'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'TV, Watch, Home'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Auto etc.'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Other'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Anything that doesn\'t fit into the categories above'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Submission Details'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Submit the topic, title, and abstract (1,500 characters max) of your talk from ',
	        _react2.default.createElement(
	          'strike',
	          null,
	          'here'
	        ),
	        '. You may edit yourapplication until the deadline with the account used for submission.',
	        _react2.default.createElement('br', null),
	        'The title, abstract, name of speaker, and other details of applications will be published regardless of their result. The above topics are for selection purposes, and are subject to change in the final timetable.'
	      ),
	      _react2.default.createElement(
	        'table',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Submission Deadline'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Oct 15, 2017 23:59 JST'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Result Announcement'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'Early-November 2017'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Tickets'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            'If selected, you will not need a ticket for admission.',
	            _react2.default.createElement('br', null),
	            'Those not selected may purchase tickets at a discount price even after they sell out.'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            'Submission Form'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'strike',
	              null,
	              _const.sessionizeUrl
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Applications are more likely to be accepted if they are:'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Android specific'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Involves an area of expertise (i.e. not about a subject widely known)'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Innovative (i.e. about a topic that demonstrates something thought to be impossible or very hard to achieve)'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Previous applications can be viewed here: ',
	        pastRequirements()
	      )
	    )
	  },
	
	  ja: {
	    title: '\u52DF\u96C6\u8981\u9805',
	    checkSubmits: '応募状況を見る',
	    submitTalk: 'トークを投稿する！',
	    finished: 'トーク応募は締め切りました。ご応募ありがとうございました。',
	    body: _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        'DroidKaigi\u3068\u306F'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'DroidKaigi\u306F\u3001Android\u6280\u8853\u60C5\u5831\u306E\u5171\u6709\u3068\u30B3\u30DF\u30E5\u30CB\u30B1\u30FC\u30B7\u30E7\u30F3\u3092\u76EE\u7684\u306B\u958B\u50AC\u3059\u308B\u3001\u30A8\u30F3\u30B8\u30CB\u30A2\u304C\u4E3B\u5F79\u306EAndroid\u30AB\u30F3\u30D5\u30A1\u30EC\u30F3\u30B9\u3067\u3059\u3002',
	        _react2.default.createElement('br', null),
	        'DroidKaigi 2017\u3067\u306F\u300176\u672C\u306E\u30BB\u30C3\u30B7\u30E7\u30F3\u306B800\u4EBA\u4EE5\u4E0A\u306E\u958B\u767A\u8005\u304C\u53C2\u52A0\u3057\u307E\u3057\u305F\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u767A\u8868\u8005\u306E\u52DF\u96C6'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'DroidKaigi 2018\u3067\u306E\u767A\u8868\u8005\u3092\u52DF\u96C6\u3057\u3066\u3044\u307E\u3059\u3002 \u6B21\u306B\u6319\u3052\u308B\u30C8\u30D4\u30C3\u30AF\u306E\u4E2D\u304B\u30891\u3064\u3092\u9078\u629E\u3057\u3066\u3001\u767A\u8868\u30BF\u30A4\u30C8\u30EB\u3068\u30A2\u30D6\u30B9\u30C8\u30E9\u30AF\u30C8\u3092\u5FDC\u52DF\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u3088\u308A\u3088\u3044\u30BB\u30C3\u30B7\u30E7\u30F3\u3092\u63A1\u629E\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u305F\u3081\u30012017\u5E74\u3088\u308A\u3082\u30C8\u30D4\u30C3\u30AF\u304C\u7D30\u5206\u5316\u3055\u308C\u307E\u3057\u305F\u3002'
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u30C8\u30D4\u30C3\u30AF'
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'UI\u30FB\u30C7\u30B6\u30A4\u30F3 (UI and Design)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30DE\u30C6\u30EA\u30A2\u30EB\u30C7\u30B6\u30A4\u30F3'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Drawables\u306E\u6271\u3044'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30A2\u30CB\u30E1\u30FC\u30B7\u30E7\u30F3 \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        '\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u30A2\u30FC\u30AD\u30C6\u30AF\u30C1\u30E3 (Designing App Architecture)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Clean Architecture'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Android Architecture Components'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'MVVM, MVC, MVP etc.'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'DI \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        '\u958B\u767A\u30D7\u30ED\u30BB\u30B9 (Development Process and Methodology)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30B0\u30ED\u30FC\u30B9\u30CF\u30C3\u30AF'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30EA\u30EA\u30FC\u30B9\u30DE\u30CD\u30B8\u30E1\u30F3\u30C8'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Android/iOS\u540C\u6642\u958B\u767A \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        '\u30C1\u30FC\u30E0\u30D3\u30EB\u30C7\u30A3\u30F3\u30B0\u30FB\u958B\u767A\u898F\u7D04 (Team Building and Development Conventions)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30C1\u30FC\u30E0\u958B\u767A\u30FB\u30D3\u30EB\u30C7\u30A3\u30F3\u30B0'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30B3\u30FC\u30C9\u30EC\u30D3\u30E5\u30FC \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'CI (CI)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'CircleCI, Jenkins, TravisCi, bitrise'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'OpenSTF, FirebaseTestLab \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        '\u30CF\u30FC\u30C9\u30A6\u30A7\u30A2 / IoT (Hardware and IoT)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30AB\u30E1\u30E9, \u30BB\u30F3\u30B5\u30FC'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u52D5\u753B\u3001\u753B\u50CF\u3001\u97F3\u58F0\u6280\u8853'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Arduino, \u30C9\u30ED\u30FC\u30F3 \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        '\u30BD\u30D5\u30C8\u30A6\u30A7\u30A2\u4FDD\u5B88\u30FB\u30C6\u30B9\u30C8 (Quality and Sustainability)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u904B\u7528'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30C6\u30B9\u30C8'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u5F8C\u65B9/\u6A5F\u7A2E\u9593\u4E92\u63DB\u6027'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Android O (Android O)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Doze'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Notification \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Android Framework\u3068Support Library (Android Framework and Support Library)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Android\u5185\u90E8\u306E\u4ED5\u7D44\u307F\u3001Media\u3001\u30D7\u30ED\u30C8\u30B3\u30EB\u30B9\u30BF\u30C3\u30AF'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'OS\u30D0\u30FC\u30B8\u30E7\u30F3\u3054\u3068\u306E\u5B9F\u88C5 \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'OSS\u958B\u767A\u30FB\u904B\u55B6 (OSS Development and Management)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u500B\u4EBA\u3067\u306EOSS\u958B\u767A\u3068\u904B\u55B6'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30B3\u30DF\u30E5\u30CB\u30C6\u30A3\u306B\u3088\u308BOSS\u958B\u767A\u3068\u904B\u55B6 \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        '\u30CF\u30F3\u30BA\u30AA\u30F3\u30FB\u30B3\u30FC\u30C9\u30E9\u30DC (Hands-on Codelabs)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Kotlin \u30CF\u30F3\u30BA\u30AA\u30F3'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30CF\u30A4\u30D6\u30EA\u30C3\u30C9\u30D5\u30EC\u30FC\u30E0\u30EF\u30FC\u30AF\u30CF\u30F3\u30BA\u30AA\u30F3'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        '\u958B\u767A\u74B0\u5883 (Productivity and Tools)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Android Studio'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u30D3\u30EB\u30C9\u30B7\u30B9\u30C6\u30E0\uFF08\u9AD8\u901F\u5316\u3001\u52B9\u7387\u5316\u7B49\uFF09'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Firebase \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        '\u30DE\u30EB\u30C1\u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0 (Platforms)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'TV, Watch, Home'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Auto \u306A\u3069'
	        )
	      ),
	      _react2.default.createElement(
	        'h3',
	        null,
	        '\u305D\u306E\u4ED6 (Other)'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          '\u4E0A\u8A18\u30C8\u30D4\u30C3\u30AF\u306B\u5165\u3089\u306A\u3044\u3082\u306E'
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        null,
	        '\u8981\u9805'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5FDC\u52DF\u5148 ',
	        _react2.default.createElement(
	          'strike',
	          null,
	          _const.sessionizeUrl
	        ),
	        ' \u306E\u30D5\u30A9\u30FC\u30E0\u3088\u308A\u767A\u8868\u306E\u30C8\u30D4\u30C3\u30AF\u3001\u30BF\u30A4\u30C8\u30EB\u3068\u30A2\u30D6\u30B9\u30C8\u30E9\u30AF\u30C8(\u6700\u59271,500\u6587\u5B57)\u7B49\u3092\u9001\u4FE1\u3057\u3066\u304F\u3060\u3055\u3044\u3002 \u9001\u4FE1\u6642\u306B\u767B\u9332\u3057\u305F\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u5229\u7528\u3059\u308B\u3053\u3068\u3067\u5FDC\u52DF\u7DE0\u3081\u5207\u308A\u307E\u3067\u306E\u9593\u3001\u81EA\u7531\u306B\u7DE8\u96C6\u3059\u308B\u3053\u3068\u304C\u53EF\u80FD\u3067\u3059\u3002',
	        _react2.default.createElement('br', null),
	        '\u5FDC\u52DF\u3044\u305F\u3060\u3044\u305F\u30BF\u30A4\u30C8\u30EB\u3084\u30BB\u30C3\u30B7\u30E7\u30F3\u7528\u6C0F\u540D\u7B49\u306F\u63A1\u629E\u3001\u975E\u63A1\u629E\u306B\u304B\u304B\u308F\u3089\u305A\u5FDC\u52DF\u72B6\u6CC1\u306B\u3066\u516C\u958B\u3055\u308C\u307E\u3059\u3002\u307E\u305F\u9078\u629E\u3057\u305F\u30C8\u30D4\u30C3\u30AF\u306F\u5BE9\u67FB\u4E0A\u306E\u3082\u306E\u3067\u3042\u308A\u3001\u30BF\u30A4\u30E0\u30C6\u30FC\u30D6\u30EB\u767A\u8868\u6642\u306E\u8868\u8A18\u3068\u7570\u306A\u308B\u5834\u5408\u304C\u3042\u308A\u307E\u3059\u3002',
	        _react2.default.createElement('br', null),
	        '\u3042\u3089\u304B\u3058\u3081\u3054\u4E86\u627F\u304F\u3060\u3055\u3044\u3002'
	      ),
	      _react2.default.createElement(
	        'table',
	        null,
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            '\u5FDC\u52DF\u671F\u9650'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '2017/10/15 23:59'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            '\u7D50\u679C\u767A\u8868\u4E88\u5B9A\u65E5'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '2017\u5E7411\u6708\u521D\u65EC'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            '\u30C1\u30B1\u30C3\u30C8'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            '\u63A1\u629E\u6642\u306F\u30C1\u30B1\u30C3\u30C8\u8CFC\u5165\u7121\u3057\u3067\u53C2\u52A0\u304C\u53EF\u80FD\u3067\u3059\u3002',
	            _react2.default.createElement('br', null),
	            '\u4E0D\u63A1\u629E\u306E\u5834\u5408\u3001\u30C1\u30B1\u30C3\u30C8\u5B8C\u58F2\u6642\u3067\u3042\u3063\u3066\u3082\u5272\u5F15\u4FA1\u683C\u3067\u8CFC\u5165\u304C\u53EF\u80FD\u3068\u306A\u308A\u307E\u3059\u3002'
	          )
	        ),
	        _react2.default.createElement(
	          'tr',
	          null,
	          _react2.default.createElement(
	            'th',
	            null,
	            '\u5FDC\u52DF\u5148'
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            _react2.default.createElement(
	              'strike',
	              null,
	              _const.sessionizeUrl
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u5FDC\u52DF\u306B\u5F53\u305F\u3063\u3066\u4EE5\u4E0B\u306E3\u70B9\u3092\u6E80\u305F\u3057\u3066\u3044\u308B\u3068\u63A1\u629E\u3055\u308C\u3084\u3059\u304F\u306A\u308A\u307E\u3059\u3002'
	      ),
	      _react2.default.createElement(
	        'ul',
	        null,
	        _react2.default.createElement(
	          'li',
	          null,
	          'Android specific: Android \u56FA\u6709\u3067\u3042\u308B\u3053\u3068'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Expertise: \u3088\u304F\u77E5\u3089\u308C\u3066\u3044\u308B\u60C5\u5831\u3067\u306F\u306A\u304F\u3001\u5C02\u9580\u6027\u304C\u3042\u308B\u3053\u3068'
	        ),
	        _react2.default.createElement(
	          'li',
	          null,
	          'Innovation: \u3044\u307E\u307E\u3067\u306B\u53EF\u80FD\u3067\u306A\u304B\u3063\u305F\u3053\u3068\u3092\u53EF\u80FD\u306B\u3057\u3066\u3044\u308B\u3053\u3068\u3001\u9769\u65B0\u6027\u304C\u3042\u308B\u3053\u3068'
	        )
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        '\u53C2\u8003\u8CC7\u6599(\u904E\u53BB\u306E\u5FDC\u52DF\u4E00\u89A7): ',
	        pastRequirements()
	      )
	    )
	  }
	});
	module.exports = exports['default'];

/***/ }),

/***/ 382:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var sessionizeUrl = exports.sessionizeUrl = 'https://sessionize.com/droidkaigi2018/';

/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _i18n = __webpack_require__(23);
	
	var _gatsbyLink = __webpack_require__(93);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactRouter = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * リンクを提供します。
	 *
	 * リンク先の URL は現在の言語設定を考慮して切り替わります。
	 */
	exports.default = (0, _reactRouter.withRouter)(function Link(_ref) {
	  var location = _ref.location,
	      to = _ref.to,
	      rest = _objectWithoutProperties(_ref, ['location', 'to']);
	
	  return _react2.default.createElement(_gatsbyLink2.default, _extends({ to: (0, _i18n.resolve)(location, to) }, rest));
	});
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-requirements-js-9b7997617453b88abcf3.js